import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class StripeDeepLinkResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/stripe_deep_links' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}